import Vue from 'vue';
import { ModalService } from '@app/plugins/iview-modal-modify/service';
import i18n from '@app/plugins/i18n';
import { ClientConfigService } from '@core/services/ClientConfigService';
class SettingsModalService extends ModalService {
  constructor() {
    super(ClientConfigService);
  }
  switchOutgoingCallRecording({ is_record }) {
    const on_record_content = i18n.t('pbx.setting.on_record');
    const off_record_content = i18n.t('pbx.setting.off_record');
    const content = is_record ? on_record_content : off_record_content;
    return this.$confirm({
      content,
      loading: true,
      showCancel: true,
      title: i18n.t('pbx.setting.record_outgoing.title'),
      onOk: () => {
        const params = { record_outgoing: is_record };
        ClientConfigService.updateConfig(params)
          .then(() => {
            this.$emit('success');
            this.modal.remove();
          })
          .catch(e => {
            this.$emit('fail');
            this.modal.setLoading(false);
            Vue.noty.server_error(e);
          });
      },
      onCancel: () => this.$emit('finally')
    });
  }
  0;
}

const instance = new SettingsModalService();
export { instance as SettingsModalService };
